<template>
  <div class="container p-1 my-4 align-items-center">
    <div class="aguarde-container text-center" v-if="this.loading">
      <div class="spinner-border" role="status"></div>
      <br />
      <span>Aguarde...</span>
    </div>
    <div v-if="!aceitou">
      <div class="py-1" v-if="!this.loading && exibirFormTitular">
        <p class="py-1 text-center">
          {{ detail.nome }}
        </p>
        <p class="text-center">
          <strong
            >PREÇO DO PLANO: R$
            {{ formatPrice(detail.valorMensal) }}/mês</strong
          >
        </p>
      </div>
      <div
        class="mt-2 mb-5 px-3 col-12 d-flex flex-column flex-lg-row"
        @click="abrirDetalhesDoPlano()"
        v-if="!this.loading && exibirFormTitular"
      >
        <button class="btn btn_color_system py-2 px-lg-5">
          VEJA OS DIFERENCIAIS DO NOSSO PLANO
          <span class="spinner-border grey ml-2" v-if="loading"></span>
        </button>
      </div>
      <h5
        v-if="!this.loading && !exibirFormTitular"
        class="py-1 mt-5 m-4 text-center"
      >
        <p class="text-uppercase">
          Olá, <strong>{{ dadosConta.pessoa.nome }}.</strong>
        </p>
        <p class="text-uppercase color-system-principal">
          <strong
            >Seja bem vindo à {{ nomeRede }}. valide suas vantagens.</strong
          >
        </p>
      </h5>
      <h5 v-if="!this.loading && exibirFormTitular" class="py-1 mt-5 m-4">
        Dados do titular
      </h5>
      <form
        v-if="!this.loading && exibirFormTitular"
        class="
          card
          my-4
          m-2
          px-5
          pt-3
          pb-5
          shadow
          needs-validation
          was-validated
        "
      >
        <section class="inputs-container">
          <div class="row g-3">
            <div class="col-sm-6 py-3">
              <label for="text" class="form-label">*CPF</label>
              <input
                type="text"
                class="form-control"
                id="cpf-input"
                v-model="dadosConta.pessoa.cpf"
                v-mask="'###.###.###-##'"
                required
              />
            </div>
            <div class="col-sm-6 py-3">
              <label for="text" class="form-label">*Matrícula</label>
              <input
                type="text"
                class="form-control"
                id="registroAssociacao1-input"
                v-model="dadosConta.pessoa.registroAssociacao1"
                required
              />
            </div>
            <div class="col-12 py-3">
              <label for="text" class="form-label"
                >* Nome completo(sem abreviaturas)</label
              >
              <input
                type="text"
                class="form-control"
                id="nome-input"
                v-model="dadosConta.pessoa.nome"
                aria-describedby="nomeHelp"
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="text" class="form-label">*Data de Nascimento</label>
              <input
                type="text"
                class="form-control"
                id="dataNascimento-input"
                v-model="dadosConta.pessoa.dataNascimento"
                format="DD/MM/YYYY"
                v-mask="'##/##/####'"
                required
                pattern=".{10}"
                placeholder="Ex: 10/10/1952"
                @blur="validarData"
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="exo" class="form-label">*Sexo</label>
              <select
                class="form-select form-control"
                required
                v-model="dadosConta.pessoa.sexo"
              >
                <option value="MASCULINO">Masculino</option>
                <option value="FEMININO">Feminino</option>
              </select>
            </div>

            <div class="col-12 py-3">
              <label for="nomeMae" class="form-label"
                >* Nome da Mãe(sem abreviaturas)</label
              >
              <input
                type="text"
                class="form-control"
                id="nomeMae-input"
                v-model="dadosConta.pessoa.nomeMae"
                required
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="celular" class="form-label">*Celular</label>
              <input
                type="text"
                class="form-control"
                id="celular-input"
                v-model="dadosConta.pessoa.telefone.telefone"
                v-mask="['(##) ####-####', '(##) #####-####']"
                required
              />
            </div>
            <div class="col-sm-6 py-3">
              <label for="fixo" class="form-label">Telefone Fixo</label>
              <input
                type="text"
                class="form-control"
                id="fixo-input"
                v-mask="['(##) ####-####', '(##) #####-####']"
              />
            </div>

            <div class="col-12 py-3">
              <label for="email" class="form-label">*E-mail</label>
              <input
                type="text"
                class="form-control"
                id="email-input"
                v-model="dadosConta.pessoa.email"
                required
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="cep" class="form-label">*CEP</label>
              <input
                type="text"
                class="form-control"
                id="cep-input"
                v-model="dadosConta.pessoa.endereco.cep"
                @keyup.enter="getByCep()"
                @blur="getByCep()"
                v-mask="'#####-###'"
                pattern=".{9}"
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="estado" class="form-label">*Estado</label>
              <select
                class="form-select form-control"
                required
                v-model="dadosConta.pessoa.endereco.estado"
              >
                <option selected>Selecione</option>
                <option value="DF">DF</option>
                <option value="GO">GO</option>
              </select>
            </div>

            <div class="col-sm-6 py-3">
              <label for="cidade" class="form-label">*Cidade</label>
              <input
                type="text"
                class="form-control"
                id="cidade-input"
                v-model="dadosConta.pessoa.endereco.cidade"
                required
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="bairro" class="form-label">*Bairro</label>
              <input
                type="text"
                class="form-control"
                id="bairro-input"
                v-model="dadosConta.pessoa.endereco.bairro"
                required
              />
            </div>
            <div class="col-sm-6 py-3">
              <label for="numero" class="form-label"> *Número</label>
              <input
                type="text"
                class="form-control"
                id="endereco-input"
                v-model="dadosConta.pessoa.endereco.numero"
                required
              />
            </div>
            <div class="col-sm-6 py-3">
              <label for="endereco" class="form-label">*Endereço</label>
              <input
                type="text"
                class="form-control"
                id="endereco-input"
                v-model="dadosConta.pessoa.endereco.endereco"
                required
              />
            </div>

            <div class="col-sm-6 py-3">
              <label for="complemento" class="form-label"> Complemento</label>
              <input
                type="text"
                class="form-control"
                id="complemento-input"
                v-model="dadosConta.pessoa.endereco.complemento"
              />
            </div>
          </div>
        </section>
      </form>
      <h5 v-if="!this.loading && exibirFormTitular" class="py-1 mt-5 m-4">
        Dependentes

        <button
          class="btn btn_color_system m-2"
          @click="mostrarFormDependentes = !mostrarFormDependentes"
        >
          <img style="width: 22px" src="@/assets/images/user-plus-solid.svg" />
        </button>
      </h5>

      <form
        @submit="incluirDependentes()"
        v-if="!this.loading && mostrarFormDependentes && exibirFormTitular"
        class="
          card
          my-4
          m-2
          px-5
          pt-3
          pb-5
          shadow
          needs-validation
          was-validated
        "
      >
        <section class="inputs-container">
          <div class="row g-3">
            <div class="col-sm-4 py-3">
              <label for="estado" class="form-label">*Parentesco</label>
              <select
                class="form-select form-control"
                aria-label="estado"
                required
                v-model="dependenteForm.parentesco"
              >
                <option value="Cônjuge/Companheiro">Cônjuge/Companheiro</option>
                <option value="Filho/Filha">Filho/Filha</option>
                <option value="Enteado/Enteada">Enteado/Enteada</option>
                <option value="Pai/Mãe">Pai/Mãe</option>
                <option value="Agregados/Outros">Agregados/Outros</option>
              </select>
            </div>
            <div class="col-sm-4 py-3">
              <label for="text" class="form-label">*CPF</label>
              <input
                type="text"
                class="form-control"
                id="cpf-input"
                v-model="dependenteForm.cpf"
                v-mask="'###.###.###-##'"
                required
              />
            </div>
            <div class="col-sm-4 py-3">
              <label for="text" class="form-label">*Data de Nascimento</label>
              <input
                type="text"
                class="form-control"
                id="dataNascimento-input"
                v-model="dependenteForm.dataNascimento"
                format="DD/MM/YYYY"
                v-mask="'##/##/####'"
                required
                pattern=".{10}"
                placeholder="Ex: 10/10/1952"
                @blur="validarData"
              />
            </div>
            <div class="col-12 py-3">
              <label for="text" class="form-label"
                >* Nome completo(sem abreviaturas)</label
              >
              <input
                type="text"
                class="form-control"
                id="nome-input"
                v-model="dependenteForm.nome"
                required
              />
            </div>
            <div
              v-if="!this.loading"
              class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row"
            >
              <button class="btn btn_color_system py-2 px-lg-5 mt-4">
                Salvar
                <span class="spinner-border grey ml-2" v-if="loading"></span>
              </button>
            </div>
            <div class="table-responsive-lg col-12">
              <table class="table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Parentesco</th>
                    <th>CPF</th>
                    <th>Data Nasc.</th>
                    <th>Nome</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in dependentes" :key="index">
                    <th style="vertical-align: middle">{{ index }}</th>
                    <td style="vertical-align: middle">
                      {{ item.parentesco }}
                    </td>
                    <td style="vertical-align: middle">{{ item.cpf }}</td>
                    <td style="vertical-align: middle">
                      {{ item.dataNascimento }}
                    </td>
                    <td style="vertical-align: middle">{{ item.nome }}</td>
                    <td style="vertical-align: middle; text-align: right">
                      <button
                        type="button"
                        v-if="!item.titular"
                        class="btn btn_color_system"
                        @click="editarDependentes(item.cpf)"
                      >
                        <img
                          style="width: 22px"
                          src="@/assets/images/user-pen-solid.svg"
                        />
                      </button>
                      <button
                        type="button"
                        v-if="!item.titular"
                        class="btn btn_color_system m-1"
                        @click="excluirDependentes(item.cpf)"
                      >
                        <img
                          style="width: 22px"
                          src="@/assets/images/user-xmark-solid.svg"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </form>
      <h5 v-if="!this.loading && exibirFormTitular" class="py-1 mt-5 m-4">
        Você precisa ler e aceitar os termos e condições para ini o processo.
      </h5>
      <div v-if="!this.loading" class="card my-4 m-2 px-5 pt-3 pb-5">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckIndeterminate"
            v-model="aceiteTermos"
          />
          <label class="form-check-label ml-2" for="flexCheckIndeterminate">
            Declaro
            <a href="#" @click="lerTermosPlanos()"> que li e concordo</a> com os
            termos e codições para associação.
          </label>
          <div class="text-center mt-3">
            <button
              @click="aceiteTermosPlanos()"
              class="btn btn_color_system_lg text-center m-2"
            >
              VALIDAR
            </button>
            <p class="mt-4">
              <a :href="linkTermos" target="_blank">CONDIÇÕES GERAIS</a> |
              <a :href="linkEstatuto" target="_blank">ESTATUTO {{ nomeRede }}</a>
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="!this.loading && exibirFormTitular"
        class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row"
      >
        <button class="btn btn_color_system py-2 px-lg-5 mt-4">
          Finalizar
          <span class="spinner-border grey ml-2" v-if="loading"></span>
        </button>
      </div>
    </div>
    <div v-if="aceitou && !exibirFormTitular && !loading">
      <h5 class="py-1 mt-5 m-4 text-center color-system-principal">
        <p>Parabéns!</p>

        <p class="text-uppercase">
          É COM MUITA SATISFAÇÃO QUE RECEBMOS VOCÊ COMO NOSSO NOVO ASSOCIADO.
        </p>

        <p>
          Acesse <a :href="site">{{ site }}</a> e saiba como utilizar suas
          vantagens!
        </p>
      </h5>
    </div>
  </div>
</template>

<script>
import { APIService } from "../../APIService";
const apiService = new APIService();

export default {
  name: "AceitePlanoCliente",
  props: [],
  data() {
    return {
      aceiteTermos: false,
      detail: {},
      mostrarFormDependentes: false,
      dadosConta: {},
      loading: false,
      dependenteForm: {},
      dependentes: [],
      exibirFormTitular: false,
      idPlano: this.$route.params.idPlano,
      nomeRede: window.NOME,
      aceitou: false,
      site: window.SITE,
      linkTermos: window.LINK_TERMOS,
      linkEstatuto: window.LINK_ESTATUTO,
    };
  },
  computed: {},
  created() {
    if (this.$route.query.formCadastro == 1) {
      this.exibirFormTitular = true;
    }
    this.obterDadosConta();
    this.obterDadosPlano(this.idPlano);
  },
  methods: {
    getByCep() {
      this.loading = true;
      apiService.getCep(this.dadosConta.pessoa.endereco.cep).then((res) => {
        this.dadosConta.pessoa.endereco = res;
        this.loading = false;
      });
    },
    validarData() {
      if (
        !this.$moment(
          this.dependenteForm.dataNascimento,
          "DD/MM/YYYY"
        ).isValid()
      )
        this.dependenteForm.dataNascimento = "";
    },
    editarDependentes(cpf) {
      for (var i = 0; i < this.dependentes.length; i++) {
        if (this.dependentes[i].cpf === cpf) {
          this.dependenteForm = this.dependentes[i];
          break;
        }
      }
    },
    incluirDependentes() {
      this.excluirDependentes(this.dependenteForm.cpf);
      this.dependentes.push(this.dependenteForm);
      this.dependenteForm = {};
    },
    excluirDependentes(cpf) {
      for (var i = 0; i < this.dependentes.length; i++) {
        if (this.dependentes[i].cpf === cpf) {
          this.dependentes.splice(i, 1);
        }
      }
    },
    formatPrice(value) {
      if (value) {
        let val = (value / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    obterDadosPlano(idPlano) {
      apiService.obterDadosPlano(idPlano).then((response) => {
        this.detail = response;
      });
    },
    obterDadosConta() {
      this.loading = true;
      apiService.dadosApp().then((response) => {
        this.dadosConta = response;
        this.loading = false;
      });
    },

    formatDate(date) {
      return this.$moment(date, "DD/MM/YYYY HH:mm:ss");
    },
    aceiteTermosPlanos() {
      if (!this.aceiteTermos) {
        this.$swal({
          title: "Termos e condições",
          html: `<div style="overflow: auto;max-height: 80vh;">${this.detail.regulamento}</div>`,
          confirmButtonText: "Aceitar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((res) => {
          if (res.isConfirmed) {
            this.aceiteTermos = true;
            if (this.exibirFormTitular) {
              this.iniciarPlano();
              this.ativarPlanoAssociado();
              this.$router.push(`/plano-do-cliente/${this.idPlano}`);
            } else {
              this.ativarPlanoAssociado();
              this.aceitou = true;
            }
          }
        });
      } else {
        if (this.exibirFormTitular) {
          this.iniciarPlano();
          this.ativarPlanoAssociado();
          this.$router.push(`/plano-do-cliente/${this.idPlano}`);
        } else {
          this.ativarPlanoAssociado();
          this.aceitou = true;
        }
      }
    },
    lerTermosPlanos() {
      this.$swal({
        title: "Termos e condições",
        html: `<div style="overflow: auto;max-height: 80vh;">${this.detail.regulamento}</div>`,
        confirmButtonText: "Aceitar",
        cancelButtonText: "Fechar",
        showCancelButton: true,
      }).then((res) => {
        this.aceiteTermos = res.isConfirmed;
      });
    },

    ativarPlanoAssociado() {
      this.loading = true;
      apiService
        .ativarPlanoAssociado(0, this.idPlano)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    iniciarPlano() {
      this.loading = true;
      this.dadosConta.dependentes = this.dependentes;
      apiService
        .iniciarPlanoAssociado(this.idPlano, this.dadosConta)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    abrirDetalhesDoPlano() {
      this.$swal({
        title: "CARACTERÍSTICAS E DIFERENCIAIS DO PLANO",
        html: `<div style="overflow: auto;max-height: 70vh;">${this.detail.descricao}</div>`,
        cancelButtonText: "Fechar",
        showCancelButton: true,
      }).then((res) => {
        this.aceiteTermos = res.isConfirmed;
      });
    },
  },
};
</script>

<style  scoped lang="scss">
.btn_color_system_lg {
  color: var(--cor-texto) !important;
  background-color: var(--cor-principal) !important;
  height: 80px;
  width: 60%;
  margin-left: 50%;
  align-content: center;
}
.color-system-principal {
  color: var(--cor-principal) !important;
}
</style>